import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChange } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PropertyService } from '../../../domain/service/propertyService'; 
import { ExternalUser } from '../../../domain/model/account/externalUser';
import { PropertyDetailDto } from '../../../domain/model/properties/propertyDetailDto';
import { AuthenticationService } from '../../../security/auth/authentication.service';
import { BrandingService } from '../../../domain/service/brandingService';

@Component({
  selector: 'app-certificate-of-registration',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './certificate-of-registration.component.html',
  styleUrl: './certificate-of-registration.component.css'
})
export class CertificateOfRegistrationComponent {
  currentYear: number = new Date().getFullYear();
  // County name / tax collector on the certificate come from global_variable (Todd: no Manatee anywhere).
  countyName = '';
  taxCollectorName = '';
  contactLine = '';
  logo = '';
  signature = '';
  issuedOn = new Date();
    externalUser:ExternalUser | null;
      model!: PropertyDetailDto;
 constructor(
  
    private readonly auth: AuthenticationService,
    private readonly propertyService: PropertyService,
    private readonly route: ActivatedRoute,
    private readonly branding: BrandingService
  ) {
    this.branding.get().subscribe(b => {
      const county = b.certCountyName || 'County';
      this.countyName = /county/i.test(county) ? county : `${county} County`;
      this.taxCollectorName = b.certTaxCollectorName || 'County Tax Collector';
      // Contact block used to be Manatee's phone/PO box/website hardcoded in the template.
      this.logo = b.logo;
      this.signature = b.signature;
      this.contactLine = [b.phone, b.streetAddress, b.website].filter(Boolean).join('  |  ');
    });
    this.externalUser = this.auth.getCurrentUser2();
    const id: string = this.route.snapshot.params["id"];

    this.propertyService.getProperty(id).subscribe((data) => {
      if (data) this.model = data;
    });
  }
}
